// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NormalScroll_wrapper__3Z4Ch"};